import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { useLanguage, CONTACTS } from "../i18n";
import { Reveal, Eyebrow } from "./Reveal";

export const Reservation = () => {
  const { t } = useLanguage();
  return (
    <section
      id="prenota"
      data-testid="reservation-section"
      className="relative py-24 sm:py-36 grain overflow-hidden"
      style={{ backgroundColor: "#480A1A" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] pointer-events-none flex items-center justify-end"
      >
        <div className="w-[90vmin] h-[90vmin] overflow-hidden translate-x-1/3">
          <img src="/logo-mark.png" alt="" className="w-full h-full object-cover scale-[2.2]" />
        </div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 sm:px-10 text-center">
        <Reveal>
          <Eyebrow light>{t.reservation.eyebrow}</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5EFE6]">
            {t.reservation.title}
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-7 text-sm sm:text-base leading-relaxed text-[#D9C6BB] max-w-2xl mx-auto">
            {t.reservation.subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.26}>
          <div className="mt-11 flex flex-col items-center gap-4">
            <a
              data-testid="superb-booking-external-btn"
              href={CONTACTS.superbUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-10 py-5 rounded-full bg-[#C69255] text-[#2C0F1A] font-meta text-xs uppercase tracking-[0.25em] hover:bg-[#D9AB72] transition-colors duration-300"
            >
              {t.reservation.superbBtn}
              <ArrowUpRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
              <a
                data-testid="phone-booking-btn"
                href={`tel:${CONTACTS.phone}`}
                className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-4 rounded-full border border-[#C69255]/45 text-[#E9DCCF] font-meta text-[11px] uppercase tracking-[0.2em] hover:border-[#C69255] hover:text-[#C69255] transition-colors duration-300"
              >
                <Phone size={15} strokeWidth={1.5} />
                {t.reservation.phoneBtn}
              </a>
              <a
                data-testid="email-booking-btn"
                href={`mailto:${CONTACTS.email}`}
                className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-4 rounded-full border border-[#C69255]/45 text-[#E9DCCF] font-meta text-[11px] uppercase tracking-[0.2em] hover:border-[#C69255] hover:text-[#C69255] transition-colors duration-300"
              >
                <Mail size={15} strokeWidth={1.5} />
                {t.reservation.emailBtn}
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.34}>
          <p className="mt-10 font-display italic text-sm sm:text-base text-[#C69255]/75 max-w-xl mx-auto">
            {t.reservation.policyNote}
          </p>
        </Reveal>

        <Reveal delay={0.4}>
          <div
            data-testid="reservation-hours"
            className="mt-14 pt-10 border-t border-[#C69255]/15"
          >
            <p className="font-meta text-[10px] uppercase tracking-[0.3em] text-[#C69255]">
              {t.reservation.hoursTitle}
            </p>
            <div className="mt-5 space-y-2">
              {t.reservation.hours.map(([d, h], i) => (
                <p key={i} className="text-sm text-[#D9C6BB]">
                  {d && <span className="text-[#F5EFE6]">{d} · </span>}
                  {h}
                </p>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
